export { default } from './Arrivals';
